import { createSelector } from '@ngrx/store';
import * as assetManagerMain from '../reducers';
import * as assetManagerMainSub from '../reducers/get-asset-managers.reducer';

export const getassetManagerRequest = createSelector(assetManagerMain.selectGetAssetManagersState, assetManagerMainSub.selectAssetManagers);

export const getassetManagerLoaded = createSelector(
  assetManagerMain.selectGetAssetManagersState,
  assetManagerMainSub.selectAssetManagersLoaded
);

export const getassetManagerFailure = createSelector(
  assetManagerMain.selectGetAssetManagersState,
  assetManagerMainSub.selectAssetManagersError
);
